import { css } from 'styled-components';
import { VariantOfType } from '../../variants';

export const CssAutocompleteDefault = css`
`;

export const autocompleteVariants = {
  default: CssAutocompleteDefault,
};

export type IAutocompleteVariants = VariantOfType<typeof autocompleteVariants>;
